
<div class="w-100 lm-border pa-3" style="height: 200px;">
    <v-row class="no-frame">
        <c-site-tzb-title
            :title         = "title"
            :rating        = "gadget.rating"
            :padding-right = "0"
        />
    </v-row>
    <template v-if="typeLabel">
        <v-row class="no-frame">
            <f-read-only-field
                :value = "gadget.type && gadget.type.name ? gadget.type.name : na"
                :label = "typeLabel"
                class  = "w-100"
                :line  = "false"
                dense
            />
        </v-row>
        <v-row class="no-frame mt-1">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    :label = "$t('unit.tzb.manufacturer')"
                    :value = "gadget.manufacturer && gadget.manufacturer.name ? gadget.manufacturer.name : na"
                    :line  = "false"
                    dense
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <f-read-only-field
                    :label = "$t('unit.escalator.model')"
                    :value = "gadget.model ? gadget.model : na"
                    :line  = "false"
                    dense
                />
            </v-col>
        </v-row>
    </template>
    <v-row class="no-frame">
        <c-site-tzb-escalator-note
            :data     = "gadget"
            :editable = "editable"
            :rows     = "typeLabel ? 1 : 4"
        />
    </v-row>
</div>
